/* --- --- --- --- PROXY CONFIGURATION --- --- --- --- */
/*
On Galaxy websites, the proxy configuration is defined in the HTML
inside a JS variable `galaxyInfo`

As we work on localhost during development,
we also have PROXY_OVERRIDE_DOMAIN that is a way to cheat
and tell the proxy to exceptionnaly use a fake domain
*/
export const PROXY_BASE_URL = `${window.galaxyInfo?.proxy_url}/tc`
export const PROXY_DOMAIN_KEY = window.galaxyInfo?.proxy_key || ''
/** Should only be used in dev mode */
export const PROXY_OVERRIDE_DOMAIN = import.meta.env.DEV
  ? import.meta.env.VITE_PROXY_OVERRIDE_DOMAIN
  : undefined

export const GOOGLE_MAPS_API_KEY = window.db2Config?.googleMaps?.apiKey
export const GOOGLE_MAPS_STYLES = window.db2Config?.googleMaps?.styles
export const HAS_DEBUG_MODE = window.galaxyInfo?.live_website === false
export const DEBUG_RFP_FORM_DATA =
  HAS_DEBUG_MODE && window.location.search.includes('debug-form-data')

/** Page language local ('en','fr', etc... ) */
export const PAGE_LANGUAGE = window.galaxyInfo?.local || 'en'
